function shapeMode(mode, scenario) {
  function extractSeqValue(seq, mde, type) {
    const modeItem = seq.filter(e => e.mode === mde).first();
    if (modeItem) {
      return modeItem[type];
    }
    return null;
  }

  function extractNodeValue(map, mde) {
    return map.get(mde);
  }

  function extractBudgetConstraint(seq, mde) {
    const constraint = seq.filter(e => e.mode === mde).first();

    if (constraint) {
      return { type: constraint.type, percent: constraint.percent };
    }
    return null;
  }

  const shapedMode = {
    key: mode,
    cost: extractSeqValue(scenario.mode_costs, mode, 'cost'),
    discountFactor: extractNodeValue(scenario.discount_f, mode),
    frequencyCap: extractSeqValue(scenario.frequency_caps, mode, 'cap'),
    relativeImpact: extractSeqValue(scenario.mode_impact_scaling, mode, 'factor'),
    budgetConstraint: extractBudgetConstraint(scenario.budget_constraint_list, mode),
    flightSize: extractNodeValue(scenario.flight_size, mode),
  };

  return shapedMode;
}

function shapeUpliftScore(scenario) {
  if (scenario.uplift_score_query) {
    return {
      type: 'queries',
      id: scenario.uplift_score_query,
    };
  }
  return null;
}

function shapeSubsetTable(scenario) {
  if (scenario.target_list_subset_table) {
    return {
      type: 'queries',
      id: scenario.target_list_subset_table,
    };
  }
  return null;
}

export function shapeScenarioForSave(organizationId, scenario) {
  const cleanScenario = scenario.config[0].config.script_arguments;

  const shapedModes = cleanScenario.mode_list.toArray().map(mode => shapeMode(mode, cleanScenario));

  const shapedScenario = {
    data: {
      type: 'scenarios',
      attributes: {
        name: cleanScenario.run_name,
        parameters: {
          totalBudget: cleanScenario.total_budget,
          crossChannelDiscountFactor: cleanScenario.cross_channel_discounting,
          targetListSubsetMode: cleanScenario.target_list_subset_mode,
          modes: shapedModes,
        },
      },
      relationships: {
        organization: {
          data: {
            type: 'organizations',
            id: String(organizationId),
          },
        },
        targetUniverse: {
          data: {
            type: 'queries',
            id: cleanScenario.target_universe_query,
          },
        },
        upliftScores: { data: shapeUpliftScore(cleanScenario) },
        targetListSubsetUniverse: { data: shapeSubsetTable(cleanScenario) },
      },
    },
  };

  return shapedScenario;
}

export function shapeScenarioForRun(scenarioId) {
  const shapedScenarioForRun = {
    data: {
      type: 'runs',
      relationships: {
        scenario: {
          data: {
            type: 'scenarios',
            id: scenarioId,
          },
        },
      },
    },
  };

  return shapedScenarioForRun;
}
